<template>
  <div v-if="item">

    <button @click="run" class="btn btn-info mb-4">ВЫПОЛНИТЬ КОМАНДУ</button>
    <br />
    <fields-list :item="item" :fields="fields" />
    <div class="save-group">
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{'save' | setText('Сохранить')}}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "system_functions",
    cardSetLink: "system_functions",
    item: null,
    fields: [
      {
        col: ' col-12 col-md-12',
        key: "system",
        label: "Выберите систему",
        type: "select",
        modal: "system",
        selectKey: 'name'
      },
      {
        col: 'col-12 col-md-12',
        label: 'Название',
        key: 'name',
        type: 'field'
      },
      {
        col: ' col-12 col-md-12',
        key: "command",
        label: "Команда",
        type: "field",

      },

    ],
  }),

  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
    },
    async run() {
       this.$loading(true);
       await this.$http.put(`${this.cardSetLink}/${this.id}`, {isRun:true}).then(()=>{
        Alert('Команда в очереди. Ожидайте выполнение.');
        this.$loading(false);
       }).catch(()=>{
        this.$loading(false);
       });


    },
  },
};
</script>
<style>

</style>
